import { z } from "zod";
import { CTA_TYPES, resolveCtaHref, isAllowedCtaHref } from "./cta.js";
import { plainTextField } from "./public-api.js";
export const promotionCtaInputSchema = z.object({
    ctaType: z.enum(CTA_TYPES).nullable().optional(),
    ctaLabel: plainTextField(60).optional().default(""),
    customApprovedUrl: z.string().url().optional(),
});
export function validatePromotionCta(input, approvedCustomUrls = []) {
    const ctaType = input.ctaType ?? null;
    if (!ctaType) {
        if (input.ctaLabel?.trim()) {
            return { ok: false, error: "CTA label requires a CTA destination" };
        }
        if (input.customApprovedUrl) {
            return { ok: false, error: "Custom URL requires CTA type custom_https" };
        }
        return { ok: true, ctaType: null, ctaLabel: "", ctaHref: null };
    }
    const label = (input.ctaLabel ?? "").trim();
    if (!label) {
        return { ok: false, error: "CTA label is required when a destination is selected" };
    }
    if (ctaType === "custom_https") {
        const href = (input.customApprovedUrl ?? "").trim();
        if (!href) {
            return { ok: false, error: "Select an approved HTTPS URL" };
        }
        if (!isAllowedCtaHref(href, approvedCustomUrls)) {
            return { ok: false, error: "URL is not in the approved allowlist" };
        }
        return { ok: true, ctaType, ctaLabel: label, ctaHref: href };
    }
    const href = resolveCtaHref(ctaType, null, approvedCustomUrls);
    if (!href) {
        return { ok: false, error: "Invalid CTA type" };
    }
    return { ok: true, ctaType, ctaLabel: label, ctaHref: href };
}
export const CTA_TYPE_LABELS = {
    whatsapp: "واتساپ پشتیبانی",
    snono_android: "Snono Connect (Android)",
    snono_ios: "Snono Connect (iOS)",
    custom_https: "HTTPS تأییدشده",
};
//# sourceMappingURL=promotion-cta.js.map